import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-10 flex flex-col md:flex-row lg:mb-15" }
const _hoisted_2 = { class: "text-2xl font-normal md:text-5xl" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "order-first md:order-last md:ml-auto" }
const _hoisted_5 = {
  key: 0,
  class: "row layout-normal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_album_action_component = _resolveComponent("my-album-action-component")!
  const _component_object_teaser_component = _resolveComponent("object-teaser-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.editMode)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.myAlbumName), 1))
            : _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.myAlbumName) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.editMode = false), ["enter"])),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMode = false)),
                ref: "albumNameInput"
              }, null, 544)), [
                [
                  _vModelText,
                  _ctx.myAlbumName,
                  void 0,
                  {
                    trim: true,
                    lazy: true
                  }
                ]
              ])
        ]),
        _createVNode(_component_my_album_action_component, {
          "my-album-name": _ctx.myAlbumName,
          "shared-album": !!_ctx.albumId,
          onEditMyAlbumName: _ctx.editMyAlbumName
        }, null, 8, ["my-album-name", "shared-album", "onEditMyAlbumName"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    (_ctx.objects)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objects, (object) => {
            return (_openBlock(), _createElementBlock("li", {
              key: object.id,
              class: "object-teaser-wrapper"
            }, [
              _createVNode(_component_object_teaser_component, {
                object: object,
                "sibling-ids": _ctx.objects.map((o) => o.id)
              }, null, 8, ["object", "sibling-ids"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}